
import { Tabs } from "antd";
import { useNavigate } from "react-router-dom";
import Getbookings from '../components/Getbookings';
import Getallrooms from "../components/Getallrooms";
import Getlluser from "../components/Getlluser";
import { useEffect } from 'react';
import AddRoom from "../components/AddRoom";
const { TabPane } = Tabs;

function Admin() {
	const user = JSON.parse(localStorage.getItem("currentuser"));
	const navigate = useNavigate();
	  useEffect(() => {

	  
		  if (!user) {
			  navigate("/login");
		  }else if (!user.isAdmin){
			navigate("/login");
		  }
		  
	  }, []);
	
  return (
		<div className="mt-3 ml-3 mr-3 bs">
			<h2 className="text-center" style={{fontSize: '30px'}}>
				<b>Admin Panel</b>
			</h2>
			<Tabs defaultActiveKey="1">
				<TabPane tab="Bookings" key="1">
					<Getbookings/>
				</TabPane>
				<TabPane tab="Rooms" key="2">
					<Getallrooms/>
				</TabPane>
				<TabPane tab="Add Rooms" key="3">
					<AddRoom/>
				</TabPane>
				<TabPane tab="Users" key="4">
					<Getlluser/>
				</TabPane>
			</Tabs>
		</div>
	);
}

export default Admin